import { PayloadActionInterface } from "@app/store/actions/payload-action.interface";
import { TwoFactorVerificationResponseInterface } from "@core/interfaces/auth/two-factor-verification.interface";
import { Action } from "@ngrx/store";

export enum Auth2FAActionTypes {
  LOGIN_2FA_REQUIRED = "[Auth] Login 2FA Required",
  VERIFY_2FA = "[Auth] Verify 2FA",
  VERIFY_2FA_SUCCESS = "[Auth] Verify 2FA Success",
  VERIFY_2FA_FAILURE = "[Auth] Verify 2FA Failure",
  CLEAR_2FA_SESSION = "[Auth] Clear 2FA Session",
  SESSION_EXPIRED = "[Auth] 2FA Session Expired"
}

export class Login2FARequired implements PayloadActionInterface {
  readonly type = Auth2FAActionTypes.LOGIN_2FA_REQUIRED;

  constructor(
    public payload: {
      sessionToken: string;
      twoFactorMethod: "totp" | "email";
      emailHint?: string;
    }
  ) {}
}

export class Verify2FA implements PayloadActionInterface {
  readonly type = Auth2FAActionTypes.VERIFY_2FA;

  constructor(
    public payload: {
      otpCode: string;
    }
  ) {}
}

export class Verify2FASuccess implements PayloadActionInterface {
  readonly type = Auth2FAActionTypes.VERIFY_2FA_SUCCESS;

  constructor(
    public payload: TwoFactorVerificationResponseInterface & {
      redirectUrl?: string;
    }
  ) {}
}

export class Verify2FAFailure implements PayloadActionInterface {
  readonly type = Auth2FAActionTypes.VERIFY_2FA_FAILURE;

  constructor(
    public payload: {
      error: any;
    }
  ) {}
}

export class Clear2FASession implements Action {
  readonly type = Auth2FAActionTypes.CLEAR_2FA_SESSION;
}

export class Session2FAExpired implements Action {
  readonly type = Auth2FAActionTypes.SESSION_EXPIRED;
}

export type Auth2FAActions =
  | Login2FARequired
  | Verify2FA
  | Verify2FASuccess
  | Verify2FAFailure
  | Clear2FASession
  | Session2FAExpired;
